module.exports = __webpack_public_path__ + "img/u14.1e7dc4f5.png";